// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sequence-config-container {
  background-color: #f5f9ff;
  border: 1px solid #e0e6eb;
  border-radius: 4px;
  padding: 23px 26px;
  position: relative;
}
.sequence-config-container .close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
}
.sequence-config-container .close-icon:hover {
  opacity: 0.7;
}
.sequence-config-container .sequence-config-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.sequence-config-container .sequence-config-body .config-row-wrapper {
  display: flex;
  gap: 10px;
}
.sequence-config-container .sequence-config-body .config-row-wrapper .and-badge {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.sequence-config-container .sequence-config-body .config-row-wrapper .and-badge span {
  background-color: #6a8991;
  border-radius: 45px;
  padding: 7px 0px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  min-width: 56px;
  text-align: center;
}
.sequence-config-container .sequence-config-body .add-row-section {
  margin-top: 5px;
}
.sequence-config-container .sequence-config-body .add-row-section .add-and-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  background-color: #40a0c1;
  border: none;
  border-radius: 45px;
  padding: 8px 18px;
  height: 33px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.sequence-config-container .sequence-config-body .add-row-section .add-and-btn:hover {
  opacity: 0.9;
}
.sequence-config-container .sequence-config-body .add-row-section .add-and-btn span {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
}

.sequence-config-empty {
  background-color: #f5f9ff;
  border: 1px solid #e0e6eb;
  border-radius: 4px;
  padding: 40px 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sequence-config-empty p {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #6a8991;
  text-align: center;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Mapping/Reports/SequenceConfig.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AACJ;AACI;EACE,YAAA;AACN;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAGI;EACE,aAAA;EACA,SAAA;AADN;AAGM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AADR;AAGQ;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AADV;AAMI;EACE,eAAA;AAJN;AAMM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;AAJR;AAMQ;EACE,YAAA;AAJV;AAOQ;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALV;;AAYA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATF;AAWE;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AATJ","sourcesContent":[".sequence-config-container {\n  background-color: #f5f9ff;\n  border: 1px solid #e0e6eb;\n  border-radius: 4px;\n  padding: 23px 26px;\n  position: relative;\n\n  .close-icon {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    cursor: pointer;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: opacity 0.2s ease;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  .sequence-config-body {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n\n    .config-row-wrapper {\n      display: flex;\n      gap: 10px;\n\n      .and-badge {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n\n        span {\n          background-color: #6a8991;\n          border-radius: 45px;\n          padding: 7px 0px;\n          font-family: \"Inter\", sans-serif;\n          font-weight: 500;\n          font-size: 14px;\n          color: #ffffff;\n          min-width: 56px;\n          text-align: center;\n        }\n      }\n    }\n\n    .add-row-section {\n      margin-top: 5px;\n\n      .add-and-btn {\n        display: flex;\n        align-items: center;\n        gap: 7px;\n        background-color: #40a0c1;\n        border: none;\n        border-radius: 45px;\n        padding: 8px 18px;\n        height: 33px;\n        cursor: pointer;\n        transition: opacity 0.2s ease;\n\n        &:hover {\n          opacity: 0.9;\n        }\n\n        span {\n          font-family: \"Inter\", sans-serif;\n          font-weight: 700;\n          font-size: 14px;\n          color: #ffffff;\n        }\n      }\n    }\n  }\n}\n\n.sequence-config-empty {\n  background-color: #f5f9ff;\n  border: 1px solid #e0e6eb;\n  border-radius: 4px;\n  padding: 40px 20px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  p {\n    font-family: \"Inter\", sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    color: #6a8991;\n    text-align: center;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
